// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federreibung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federreibungDE: PageEntry = {
  id: "post.federreibung",
  locale: "de",
  slug: "federreibung",
  seo: {
    title: "Glossar: Federreibung einfach erklärt | Dietz GmbH",
    description: "Die Federreibung bezieht sich auf die interne Reibung, die in einer Feder während ihrer Verformung auftritt. Diese Reibung kann die Leistung einer Feder beeinflussen, indem sie Ene",
  },
  type: "post",
  h1: "Glossar: Federreibung einfach erklärt",
  intro: "Die Federreibung bezieht sich auf die interne Reibung, die in einer Feder während ihrer Verformung auftritt. Diese Reibung kann die Leistung einer Feder beeinflussen, indem sie Energie absorbiert und die Bewegung beeinträchtigt. Ein genaues Verständnis der Federreibung ist entscheidend, um unerwünschte Energieverluste zu minimieren und die Effizienz von Feder-Systemen zu maximieren. Ingenieure berücksichtigen die Federreibung bei der Auswahl von Materialien, Schmiermitteln und Konstruktionsparametern, um optimale Leistung und Lebensdauer zu gewährleisten. Die Kontrolle der Federreibung spielt eine wichtige Rolle in Anwendungen, in denen Präzision und Wiederholbarkeit erforderlich sind.",
  blocks: [

  ],
};
